import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import ResearchSection from "../components/Research";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function Research(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <ResearchSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
